import { render } from "./tw-date-picker.vue?vue&type=template&id=56c3713b"
import script from "./tw-date-picker.vue?vue&type=script&lang=js"
export * from "./tw-date-picker.vue?vue&type=script&lang=js"
script.render = render

export default script